import { decorate, observable } from "mobx";
import CustomClipsStore from "./CustomClipsStore";

class MyCustomClipsStore extends CustomClipsStore {
  fetchClips(params) {
    this.sportyApi.getUserCustomClips(params).then(result => {
      this.clips = result.customClips;
      this.totalClips = result.total;
    });
  }
}

decorate(MyCustomClipsStore, {
  gamePk: observable,
  description: observable,
  page: observable,
  clips: observable,
  clipsPerPage: observable,
  totalClips: observable
});

export default MyCustomClipsStore;



// WEBPACK FOOTER //
// ./src/stores/customClips/MyCustomClipsStore.js